import script from "./InspectorTexture.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorTexture.vue?vue&type=script&setup=true&lang=js"

import "./InspectorTexture.vue?vue&type=style&index=0&id=441a248c&scoped=true&lang=scss"
import "./InspectorTexture.vue?vue&type=style&index=1&id=441a248c&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441a248c"]])

export default __exports__